var _path, _path2, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupplierApplicationRejectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "#2F4858",
    stroke: "#2F4858",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 68C16.7746 68 2 53.2254 2 35C2 16.7746 16.7746 2 35 2C53.2254 2 68 16.7746 68 35C68 53.2254 53.2254 68 35 68Z",
    stroke: "#2F4858",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5765 50C47.1186 44.6864 41.7404 41 35.5011 41C29.2619 41 23.8837 44.6864 21.4258 50",
    stroke: "#2F4858",
    strokeWidth: 4,
    strokeLinecap: "round",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 25,
    r: 4,
    fill: "#2F4858",
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 4,
    fill: "#2F4858",
    stroke: "none"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierApplicationRejectedIcon);
export default __webpack_public_path__ + "static/media/SupplierApplicationRejectedIcon.2a802bd7.svg";
export { ForwardRef as ReactComponent };